/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Session_30_HintInputs */

const en_us2_profile_editors_session_30_hint = /** @type {(inputs: Profile_Editors_Session_30_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fewer exercises, the essentials`)
};

const pt_br2_profile_editors_session_30_hint = /** @type {(inputs: Profile_Editors_Session_30_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menos exercícios, o essencial`)
};

const es_419_profile_editors_session_30_hint = /** @type {(inputs: Profile_Editors_Session_30_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menos ejercicios, lo esencial`)
};

const pt_pt2_profile_editors_session_30_hint = /** @type {(inputs: Profile_Editors_Session_30_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menos exercícios, o essencial`)
};

const fr_fr2_profile_editors_session_30_hint = /** @type {(inputs: Profile_Editors_Session_30_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moins d'exercices, l'essentiel`)
};

const de_de2_profile_editors_session_30_hint = /** @type {(inputs: Profile_Editors_Session_30_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weniger Übungen, das Wesentliche`)
};

const it_it2_profile_editors_session_30_hint = /** @type {(inputs: Profile_Editors_Session_30_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meno esercizi, l'essenziale`)
};

/**
* | output |
* | --- |
* | "Fewer exercises, the essentials" |
*
* @param {Profile_Editors_Session_30_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_session_30_hint = /** @type {((inputs?: Profile_Editors_Session_30_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Session_30_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_session_30_hint(inputs)
	if (locale === "es-419") return es_419_profile_editors_session_30_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_session_30_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_session_30_hint(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_session_30_hint(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_session_30_hint(inputs)
	return en_us2_profile_editors_session_30_hint(inputs)
});
export { profile_editors_session_30_hint as "profile-editors.session_30_hint" }